import React from 'react'
import { Image, Text, Box, Flex, Group, Progress } from '@mantine/core'
import Banregio from "../../assets/banks/banregio.webp";
import Azteca from "../../assets/banks/azteca.webp";
import Bbva from "../../assets/banks/bbva2.png";
import Hsbc from "../../assets/banks/hsbc.png";
import MercadoPago from "../../assets/banks/mercado-pago.webp";
import Santander from "../../assets/banks/santander-logo-1.webp";
import Efectivo from "../../assets/banks/efectivo.png";
import Spin from "../../assets/banks/spin.png";

const BoxBank = ({ title, value, percentage = 0 }) =>
{
  const bankImages = {
    "mercado pago": MercadoPago,
    "bbva": Bbva,
    "santander": Santander,
    "hsbc": Hsbc,
    "banregio": Banregio,
    "azteca": Azteca,
    "efectivo": Efectivo,
    "spin": Spin,
  };

  const renderBankImage = (bankName) => {
    // Normalizamos el nombre a minúsculas para la búsqueda
    const normalizedName = bankName?.toLowerCase();
    const imageSrc = bankImages[normalizedName];

    return (
      <Box 
        style={{ 
          width: 24, 
          height: 24, 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center'
        }}
      >
        <Image
          src={ imageSrc }
          alt={ bankName }
          className="object-contain"
        />
      </Box>
    );
  };

  return (
    <Box py="xs" style={{ borderBottom: '1px solid var(--mantine-color-gray-2)' }}>
      <Flex justify="space-between" align="center" mb={4}>
        <Group gap="xs">
          { renderBankImage(title) }
          <Text size="xs" fw={700} tt="uppercase" c="gray.7">
            { title }
          </Text>
        </Group>
        <Text 
          size="sm" 
          fw={700} 
          style={{ fontFamily: 'var(--mantine-font-family-monospace)' }}
        >
          { value }
        </Text>
      </Flex>
      
      {/* Volume Indicator Signature */}
      <Progress 
        value={percentage} 
        size="2px" 
        color="yellow.5" 
        radius="xs" 
        styles={{ root: { backgroundColor: 'var(--mantine-color-gray-1)' } }}
      />
    </Box>
  )
}

export default BoxBank
